import * as constants from '../constants'
import { BondTradingPane } from '../types'
import { Action } from 'redux'
import { BondBuyMode, BondConfigItem } from '@bdswiss/mt4-connector'

export interface SetBondAmount {
  type: constants.SET_BOND_AMOUNT
  bondAmount: number
}

export function setBondAmount(bondAmount: number): SetBondAmount {
  return {
    type: constants.SET_BOND_AMOUNT,
    bondAmount,
  }
}

export interface SelectBond {
  type: constants.SELECT_BOND
  bond: BondConfigItem
}

export function selectBond(bond: BondConfigItem): SelectBond {
  return {
    type: constants.SELECT_BOND,
    bond,
  }
}

export interface ViewBondDetails {
  type: constants.VIEW_BOND_DETAILS
  bond: BondConfigItem
}

export function viewBondDetails(bond: BondConfigItem): ViewBondDetails {
  return {
    type: constants.VIEW_BOND_DETAILS,
    bond,
  }
}

export interface ShowBondDetailDialog extends Action {
  type: constants.SHOW_BOND_DETAIL_DIALOG
}

export function showBondDetailDialog(): ShowBondDetailDialog {
  return {
    type: constants.SHOW_BOND_DETAIL_DIALOG,
  }
}

export interface HideBondDetailDialog extends Action {
  type: constants.HIDE_BOND_DETAIL_DIALOG
}

export function hideBondDetailDialog(): HideBondDetailDialog {
  return {
    type: constants.HIDE_BOND_DETAIL_DIALOG,
  }
}

export interface CloseBondDetails {
  type: constants.CLOSE_BOND_DETAILS
}

export function closeBondDetails(): CloseBondDetails {
  return {
    type: constants.CLOSE_BOND_DETAILS,
  }
}

export interface ClearSelectBond {
  type: constants.CLEAR_SELECT_BOND
}

export function clearSelectBond(): ClearSelectBond {
  return {
    type: constants.CLEAR_SELECT_BOND,
  }
}

export interface GetBondConfig extends Action {
  type: constants.GET_BOND_CONFIG
}

export function getBondConfig(): GetBondConfig {
  return {
    type: constants.GET_BOND_CONFIG,
  }
}

export interface FulfillBonds extends Action {
  type: constants.FULFILL_BONDS
  bonds: BondConfigItem[]
}

export function fulfillBonds(bonds: BondConfigItem[]): FulfillBonds {
  return {
    type: constants.FULFILL_BONDS,
    bonds,
  }
}

export interface UpdateBondTradingPane extends Action {
  type: constants.UPDATE_BOND_TRADING_PANE
  pane: BondTradingPane
}

export function updateBondTradingPane(pane: BondTradingPane): UpdateBondTradingPane {
  return {
    type: constants.UPDATE_BOND_TRADING_PANE,
    pane,
  }
}

export interface BuyBondAction extends Action {
  type: constants.BUY_BOND
  mt4Symbol: string
  volume: number
}

export function buyBondAction(mt4Symbol: string, volume: number): BuyBondAction {
  return {
    type: constants.BUY_BOND,
    mt4Symbol,
    volume,
  }
}

export interface ChangeBondBuyModeAction extends Action {
  type: constants.CHANGE_BOND_BUY_MODE
  buyMode: BondBuyMode
}
export function changeBondBuyModeAction(buyMode: BondBuyMode): ChangeBondBuyModeAction {
  return {
    type: constants.CHANGE_BOND_BUY_MODE,
    buyMode,
  }
}

export type BondActions =
  | SelectBond
  | ViewBondDetails
  | CloseBondDetails
  | ClearSelectBond
  | GetBondConfig
  | ChangeBondBuyModeAction
  | ShowBondDetailDialog
  | HideBondDetailDialog
